import axios from 'axios';
import React, { useState, useEffect } from 'react';
import constants from '../../constants'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Loading from '../../components/loading/Loading'
import leaves from '../../assets/icons/ingredients/leaves.svg'
import roots from '../../assets/icons/ingredients/roots.svg'
import blossoms from '../../assets/icons/ingredients/blossoms.svg'
import vines from '../../assets/icons/ingredients/vines.svg'
import seeds from '../../assets/icons/ingredients/seeds.svg'
import fruit from '../../assets/icons/ingredients/fruit.svg'
import stalks from '../../assets/icons/ingredients/stalks.svg'
import moss from '../../assets/icons/ingredients/moss.svg'
import RefreshIcon from '@mui/icons-material/Refresh';
import './Ingredients.css'

import toast from 'react-hot-toast';
import ReactivityHex from './components/ReactivityHex';
import { climateSearchDictionary } from './utilities/climates';
import { geographicLocations } from './utilities/locations';

const iconDictionary = {
    "Leaves": leaves,
    "Roots": roots,
    "Blossoms": blossoms,
    "Vines": vines,
    "Seeds": seeds,
    "Fruit": fruit,
    "Stalks": stalks,
    "Moss": moss,
}

export default function Ingredients() {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    const [climateID, setClimateID] = useState(null)
    const [location, setLocation] = useState(null)

    useEffect(() => {
        const splitUrl = window.location.href.split('/')
        if (splitUrl.length > 4 && items.length === 0) {
            setLoading(true)
            axios.post(constants.baseUrl + '/api/searchIngredients?searchTerm=' + splitUrl[4]).then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        } else if (items.length === 0) {
            axios.post(constants.baseUrl + '/api/getRandomIngredients?numberOfItems=25').then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        }
    }, [loading]);

    function refreshItems() {
        setLoading(true)
        axios.post(constants.baseUrl + '/api/getRandomIngredients?numberOfItems=25', { climateID, location }).then(({ data }) => {
            setItems(data);
            setLoading(false)
        })
    }

    function getIngredientByNameOrPotion(event) {
        setLoading(true)
        axios.post(constants.baseUrl + '/api/searchIngredients?searchTerm=' + event.target.value, { climateID, location }).then(({ data }) => {
            setItems(data);
            setLoading(false)
        })
    }

    function getIngredientByClimate(newClimateID) {
        setLoading(true)
        if (climateID === newClimateID) {
            setClimateID(null)
            refreshItems()
        } else {
            setClimateID(newClimateID)
            axios.post(constants.baseUrl + '/api/getRandomIngredients?numberOfItems=25', { climateID: newClimateID, location }).then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        }
    }

    function getIngredientByLocation(newLocation) {
        setLoading(true)
        if (location === newLocation) {
            setLocation(null)
            refreshItems()
        } else {
            setLocation(newLocation)
            axios.post(constants.baseUrl + '/api/searchIngredientsByLocation?location=' + newLocation, { climateID, location: newLocation }).then(({ data }) => {
                setItems(data);
                setLoading(false)
            })
        }
    }

    const [newIngredients, setNewIngredients] = useState([])

    function getRandomIngredients(rarity) {
        setNewIngredients([])
        axios.get(constants.baseUrl + '/api/getRandomIngredients/' + rarity).then(({ data }) => {
            setNewIngredients(data)
        })
    }

    return (
        <div>
            {loading && <Loading />}
            {!loading && (
                <div className='ingredients'>
                    <a className='header-link' href='https://docs.google.com/document/d/1_yay6puDxpBabz-ryNCQXCibRdljvdTKyGKzDHgURmo/edit?usp=sharing' target='_blank'>
                        <div>
                            Brewing Rules Here
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </div>
                    </a>
                    <div className='input-shell climates-shell'>
                        {climateSearchDictionary.map(climate => <button onClick={_ => getIngredientByClimate(climate.id)} className={climateID === climate.id ? '' : 'secondary'} key={climate.climate}>{climate.climate}</button>)}
                    </div>
                    <div className='input-shell climates-shell'>
                        {geographicLocations.map(geoLocation => <button onClick={_ => getIngredientByLocation(geoLocation)} className={location === geoLocation ? '' : 'secondary'} key={geoLocation}>{geoLocation}</button>)}
                    </div>
                    <div className='input-shell'>
                        <div>
                            <input onBlur={getIngredientByNameOrPotion}></input>
                            <p>Search Ingredients by Name or Potion</p>
                        </div>
                        <button onClick={refreshItems}><RefreshIcon /></button>
                    </div>

                    <div className='accordion-shell'>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography component={'span'} variant={'body2'}>
                                    <div className='potion-shell'>
                                        <div className='ingredient-basic-info'>
                                            <div className='item-title-shell'>
                                                <h3>Generate Random Ingredients</h3>
                                            </div>
                                        </div>
                                    </div>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography component={'span'} variant={'body2'}>
                                    <div className='item-detail-shell new-ingredients'>
                                        <p>for a...</p>
                                        <div>
                                            <button onClick={_ => getRandomIngredients(2)}>Common Potion</button>
                                            <button onClick={_ => getRandomIngredients(3)}>Uncommon Potion</button>
                                            <button onClick={_ => getRandomIngredients(5)}>Rare Potion</button>
                                        </div>

                                        <div className='smaller-ingredient-shell'>
                                            {newIngredients.map(({ id, ingredientName, translate, corrupt, harvestablePart, locations, reactivity }) => {
                                                return (
                                                    <div key={id}>
                                                        <div>
                                                            <img src={iconDictionary[harvestablePart]} height="35" />
                                                            <span>
                                                                <h4>{ingredientName}</h4>
                                                                {translate && <p>(translate to another language)</p>}
                                                                {corrupt && <p>(corrupt this name)</p>}
                                                            </span>
                                                            <ReactivityHex reactivity={reactivity} />
                                                        </div>
                                                        <ul>
                                                            {locations.map(({ adjacency, location }, i) => (<li key={adjacency + location + i}>{adjacency} {location}</li>))}
                                                        </ul>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>

                    <br />

                    <div className='accordion-shell'>
                        {items.map((item, i) => {
                            return (
                                <Accordion key={i}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography component={'span'} variant={'body2'}>
                                            <div className='potion-shell'>
                                                <img src={iconDictionary[item.harvestablePart]} height="50" />
                                                <div className='ingredient-basic-info'>
                                                    <div className='item-title-shell'>
                                                        <h2>{item.ingredientName}</h2>
                                                    </div>
                                                    <a href={'/potions/' + item.potion.name} target='_blank'>
                                                        {item.potion.name}
                                                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                                    </a>
                                                </div>
                                                <ReactivityHex reactivity={item.reactivity} />
                                            </div>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography component={'span'} variant={'body2'}>
                                            <div className='item-detail-shell'>
                                                <div className='item-detail'><h3>Harvestable Part</h3> <p>{item.harvestablePart}</p></div>
                                                {item.classifications && item.classifications.length > 0 && <div><h3>Climates(s)</h3> <ul>{item.classifications.map((climate, i) => (<li key={climate.climate + i}>{climate.climate}</li>))}</ul></div>}
                                                {item.locations && item.locations.length > 0 && <div><h3>Location(s)</h3> <ul>{item.locations.map(({ adjacency, location }, i) => (<li key={adjacency + location + i}>{adjacency} {location}</li>))}</ul></div>}
                                            </div>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}